export const saveSetup = (data) => async (dispatch, getState, api) => {
    try {
        return await api.post(`/xrayAudit/setup`, {data});
    } catch (err) {
        console.error(err);
        return err;
    }
};
export const getSetup = () => async (dispatch, getState, api) => {
    try {
        const setups = await api.get(`/xrayAudit/setup`);
        return mapSetups(setups);
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const getAuditReviewer = () => async (dispatch, getState, api) => {
    try {
        const reviewers = await api.get(`/xrayAudit/reviewer`);
        return reviewers;
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const getAuditReviewee = () => async (dispatch, getState, api) => {
    try {
        const reviewees = await api.get(`/xrayAudit/reviewee`);
        return reviewees;
    } catch (err) {
        console.error(err);
        return [];
    }
};


export const getGroupedQuestions = (params) => async (dispatch, getState, api) => {
    try {
        const queryString = Object.keys(params)
            .filter(key => params[key])
            .map(key => `${key}=${params[key]}`).join('&');
        const response = await api.get(`/xrayAudit/grouped-questions?${queryString}`);
        return response;
    } catch (err) {
        console.error(err);
        return [];
    }
};

const mapSetups = (setups) => {
    return (setups || []).map(setup => ({
        ...setup,
        procCodes: (setup.procCodes || '').split(',').filter(f => f.length),
        brands: (setup.brands || '').split(',').filter(f => f.length),
        followUpCodes: (setup.followUpCodes || '').split(',').filter(f => f.length)
    }));
}

export const getAudits = (params = {}) => async (dispatch, getState, api) => {
    try {
        const queryString = Object.keys(params)
            .filter(key => params[key])
            .map(key => `${key}=${params[key]}`).join('&');
        const auditeeUserId = params.auditeeUserId ? `auditeeUserId=${params.auditeeUserId}` : '';
        const includeAuditeeUserId = !queryString.includes('auditeeUserId');
        const finalQueryString = includeAuditeeUserId ? `${queryString}${queryString ? '&' : ''}${auditeeUserId}` : queryString;
        return await api.get(`/xrayAudit?${finalQueryString}`);
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const getScores = (params = {}) => async (dispatch, getState, api) => {
    try {
        const queryString = Object.keys(params)
            .filter(key => params[key])
            .map(key => `${key}=${params[key]}`).join('&');
        return await api.get(`/xrayAudit/scores?${queryString}`);
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const saveAudit = (data) => async (dispatch, getState, api) => {
    try {
        return await api.post(`/xrayAudit`, {data});
    } catch (err) {
        console.error(err);
        return err;
    }
};
export const executeLambdaFunction = (setupId) => async (dispatch, getState, api) => {
    try {
        return await api.get(`/xrayAudit/executeLambdaFunction/${setupId}`);
    } catch (error) {
        console.error(error);
        return 0;
    }
};

export const getDashboard = (userId, params) => async (dispatch, getState, api) => {
    try {
        return await api.get(`/xrayAudit/dashboard/${userId}`);
    } catch (err) {
        console.error(err);
        return [];
    }
};


export const getLogs = (setupId) => async (dispatch, getState, api) => {
    try {
        return await api.get(`/xrayAudit/logs?setupId=${setupId}`);
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const updateXrayReview = (xrayReviewId) => async (dispatch, getState, api) => {
    try {
        return await api.put(`/xrayAudit/${xrayReviewId}`);
    } catch (err) {
        console.error(err);
        return err;
    }
};

export const updateXrayReviewValues = (params={}) => async (dispatch, getState, api) => {
    try {
        const queryString = Object.keys(params)
            .filter(key => params[key])
            .map(key => `${key}=${params[key]}`).join('&');
        return await api.put(`/xrayAudit/updateReviewValues?${queryString}`);
    } catch (err) {
        console.error(err);
        return err;
    }
};

export const emailResults = (payload) => async (dispatch, getState, api) => {
    try {
        return await api.post(`/xrayAudit/emailResults`, {data: payload});
    } catch (err) {
        console.error(err);
        return err;
    }
};

export const getReviewSummary = (params = {}) => async (dispatch, getState, api) => {
    try {
        const queryString = Object.keys(params)
            .filter(key => params[key])
            .map(key => `${key}=${params[key]}`).join('&');
        const auditeeUserId = params.auditeeUserId ? `auditeeUserId=${params.auditeeUserId}` : '';
        const includeAuditeeUserId = !queryString.includes('auditeeUserId');
        const finalQueryString = includeAuditeeUserId ? `${queryString}${queryString ? '&' : ''}${auditeeUserId}` : queryString;
        return await api.get(`/xrayAudit/reviewSummary?${finalQueryString}`);
    } catch (err) {
        console.error(err);
        return [];
    }
};


export const sendHistory = (data) => async (dispatch, getState, api) => {
    try {
        return await api.post('/xrayAudit/sendHistory', {data});
    } catch (error) {
        console.error("sendHistory::", error);
        return error;
    }
};

export const getProviderNotificationHistory = (data) => async (dispatch, getState, api) => {
    try {
        return await api.post('/xrayAudit/getProviderNotificationHistory', {data});
    } catch (error) {
        console.error("getProviderNotificationHistory::", error);
        return error;
    }
};